import {BookmarkV2Client, BookmarkV2PatchParams, Scope} from 'common/report/queries/app-api/bookmark-client';
import {PostV2Request} from 'app_api/projects/bookmarks/types';
import {savedReportsLimitStore} from 'common/report/stores/saved-reports-limit';
import {getOwnAttr} from 'common/util';

import {Bookmark} from '../dashboards/types';
import {Store} from './store';

export interface BookmarksMap {
  [bookmarkId: string]: Bookmark<any>;
}

export class BookmarkStore extends Store<BookmarksMap> {
  public async getOrFetch<BookmarkParamsType>(id: number | string): Promise<Bookmark<BookmarkParamsType>> {
    const key = String(id);
    if (!(key in this.value)) {
      await this.refresh({id}, {clearCache: true}, key);
    }
    return getOwnAttr(this.value, key);
  }

  public async fetchFresh<BookmarkParamsType>(id: number | string): Promise<Bookmark<BookmarkParamsType>> {
    const key = String(id);
    await this.refresh({id}, {clearCache: true}, key);
    return getOwnAttr(this.value, key);
  }

  public async createOrUpdate<BookmarkParamsType>(
    newOrUpdatedBookmarkFields: BookmarkV2PatchParams<BookmarkParamsType> | PostV2Request,
    {saveAsNew = false} = {},
  ): Promise<Bookmark<BookmarkParamsType>> {
    if (saveAsNew) {
      return this.post(newOrUpdatedBookmarkFields);
    } else {
      return this.patch(newOrUpdatedBookmarkFields as BookmarkV2PatchParams<BookmarkParamsType>);
    }
  }
}

// store for individual bookmarks
export function createBookmarkStore(projectScope: Scope): BookmarkStore {
  const bookmarkStore = new BookmarkStore({
    apiClient: new BookmarkV2Client(projectScope),
    defaultValue: {},
    name: `bookmark`,
    transform: {
      index: (bookmark) => ({[String(bookmark.id)]: bookmark}),
      update: (bookmark) => ({k: String(bookmark.id), v: bookmark}),
    },
  });

  // an empty-key subscription will only trigger on Store.post() and Store.delete(),
  // so effectively this means "update the saved reports limit store when a bookmark is created or deleted"
  bookmarkStore.subscribe(() => {
    savedReportsLimitStore.refresh({projectId: projectScope.projectId}); // async, no need to wait
  });

  return bookmarkStore;
}
